import ye from "../node_modules/@babel/runtime/helpers/esm/extends.js";
import y from "../node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import Ye from "../node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import Ue from "../node_modules/@babel/runtime/helpers/esm/createClass.js";
import ze from "../node_modules/@babel/runtime/helpers/esm/inherits.js";
import je from "../node_modules/@babel/runtime/helpers/esm/createSuper.js";
import Be from "../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElement as ee, Component as Qe, useMemo as j, Fragment as re, useRef as Y, useCallback as w, useEffect as Me } from "react";
import { z as fe, A as _e, B as be, C as ge, D as te, E as $e, F as Ke, H as qe, I as ve, J as he, K as et, M as tt, r as ut, a as nt, b as it, d as ot, e as at, g as st, f as rt, i as lt, h as ct, j as dt, l as pt, k as ft, m as bt, n as gt, o as vt, p as ht, q as mt, t as Ct, u as It, v as Et, w as Ft, x as At, y as Vt, G as Dt, s as xt } from "./index-a86253bb.esm.js";
import { createElement as L, css as St } from "../../@emotion/react/dist/emotion-react.browser.esm.js";
import Ot from "../../memoize-one/dist/memoize-one.esm.js";
import yt from "../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import { jsx as E, jsxs as ue } from "../../../_virtual/jsx-runtime.js";
function Bt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Mt = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Bt
}, me = function(n) {
  return L("span", ye({
    css: Mt
  }, n));
}, Lt = {
  guidance: function(n) {
    var s = n.isSearchable, a = n.isMulti, e = n.isDisabled, i = n.tabSelectsValue, c = n.context;
    switch (c) {
      case "menu":
        return "Use Up and Down to choose options".concat(e ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(i ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return "".concat(n["aria-label"] || "Select", " is focused ").concat(s ? ",type to refine list" : "", ", press Down to open the menu, ").concat(a ? " press left to focus selected values" : "");
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(n) {
    var s = n.action, a = n.label, e = a === void 0 ? "" : a, i = n.labels, c = n.isDisabled;
    switch (s) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(e, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(i.length > 1 ? "s" : "", " ").concat(i.join(","), ", selected.");
      case "select-option":
        return c ? "option ".concat(e, " is disabled. Select another option.") : "option ".concat(e, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(n) {
    var s = n.context, a = n.focused, e = n.options, i = n.label, c = i === void 0 ? "" : i, t = n.selectValue, u = n.isDisabled, o = n.isSelected, l = function(b, g) {
      return b && b.length ? "".concat(b.indexOf(g) + 1, " of ").concat(b.length) : "";
    };
    if (s === "value" && t)
      return "value ".concat(c, " focused, ").concat(l(t, a), ".");
    if (s === "menu") {
      var d = u ? " disabled" : "", f = "".concat(o ? "selected" : "focused").concat(d);
      return "option ".concat(c, " ").concat(f, ", ").concat(l(e, a), ".");
    }
    return "";
  },
  onFilter: function(n) {
    var s = n.inputValue, a = n.resultsMessage;
    return "".concat(a).concat(s ? " for search term " + s : "", ".");
  }
}, Gt = function(n) {
  var s = n.ariaSelection, a = n.focusedOption, e = n.focusedValue, i = n.focusableOptions, c = n.isFocused, t = n.selectValue, u = n.selectProps, o = n.id, l = u.ariaLiveMessages, d = u.getOptionLabel, f = u.inputValue, v = u.isMulti, b = u.isOptionDisabled, g = u.isSearchable, p = u.menuIsOpen, h = u.options, A = u.screenReaderStatus, I = u.tabSelectsValue, m = u["aria-label"], B = u["aria-live"], C = j(function() {
    return y(y({}, Lt), l || {});
  }, [l]), D = j(function() {
    var S = "";
    if (s && C.onChange) {
      var O = s.option, J = s.options, R = s.removedValue, _ = s.removedValues, $ = s.value, K = function(Z) {
        return Array.isArray(Z) ? null : Z;
      }, H = R || O || K($), V = H ? d(H) : "", x = J || _ || void 0, W = x ? x.map(d) : [], X = y({
        isDisabled: H && b(H, t),
        label: V,
        labels: W
      }, s);
      S = C.onChange(X);
    }
    return S;
  }, [s, C, b, t, d]), F = j(function() {
    var S = "", O = a || e, J = !!(a && t && t.includes(a));
    if (O && C.onFocus) {
      var R = {
        focused: O,
        label: d(O),
        isDisabled: b(O, t),
        isSelected: J,
        options: i,
        context: O === a ? "menu" : "value",
        selectValue: t
      };
      S = C.onFocus(R);
    }
    return S;
  }, [a, e, d, b, C, i, t]), M = j(function() {
    var S = "";
    if (p && h.length && C.onFilter) {
      var O = A({
        count: i.length
      });
      S = C.onFilter({
        inputValue: f,
        resultsMessage: O
      });
    }
    return S;
  }, [i, f, p, C, h, A]), k = j(function() {
    var S = "";
    if (C.guidance) {
      var O = e ? "value" : p ? "menu" : "input";
      S = C.guidance({
        "aria-label": m,
        context: O,
        isDisabled: a && b(a, t),
        isMulti: v,
        isSearchable: g,
        tabSelectsValue: I
      });
    }
    return S;
  }, [m, a, e, v, b, g, p, C, t, I]), U = "".concat(F, " ").concat(M, " ").concat(k), T = L(re, null, L("span", {
    id: "aria-selection"
  }, D), L("span", {
    id: "aria-context"
  }, U)), N = (s == null ? void 0 : s.action) === "initial-input-focus";
  return L(re, null, L(me, {
    id: o
  }, N && T), L(me, {
    "aria-live": B,
    "aria-atomic": "false",
    "aria-relevant": "additions text"
  }, c && !N && T));
}, le = [{
  base: "A",
  letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
}, {
  base: "AA",
  letters: "\uA732"
}, {
  base: "AE",
  letters: "\xC6\u01FC\u01E2"
}, {
  base: "AO",
  letters: "\uA734"
}, {
  base: "AU",
  letters: "\uA736"
}, {
  base: "AV",
  letters: "\uA738\uA73A"
}, {
  base: "AY",
  letters: "\uA73C"
}, {
  base: "B",
  letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
}, {
  base: "C",
  letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
}, {
  base: "D",
  letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
}, {
  base: "DZ",
  letters: "\u01F1\u01C4"
}, {
  base: "Dz",
  letters: "\u01F2\u01C5"
}, {
  base: "E",
  letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
}, {
  base: "F",
  letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
}, {
  base: "G",
  letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
}, {
  base: "H",
  letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
}, {
  base: "I",
  letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
}, {
  base: "J",
  letters: "J\u24BF\uFF2A\u0134\u0248"
}, {
  base: "K",
  letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
}, {
  base: "L",
  letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
}, {
  base: "LJ",
  letters: "\u01C7"
}, {
  base: "Lj",
  letters: "\u01C8"
}, {
  base: "M",
  letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
}, {
  base: "N",
  letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
}, {
  base: "NJ",
  letters: "\u01CA"
}, {
  base: "Nj",
  letters: "\u01CB"
}, {
  base: "O",
  letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
}, {
  base: "OI",
  letters: "\u01A2"
}, {
  base: "OO",
  letters: "\uA74E"
}, {
  base: "OU",
  letters: "\u0222"
}, {
  base: "P",
  letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
}, {
  base: "Q",
  letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
}, {
  base: "R",
  letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
}, {
  base: "S",
  letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
}, {
  base: "T",
  letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
}, {
  base: "TZ",
  letters: "\uA728"
}, {
  base: "U",
  letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
}, {
  base: "V",
  letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
}, {
  base: "VY",
  letters: "\uA760"
}, {
  base: "W",
  letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
}, {
  base: "X",
  letters: "X\u24CD\uFF38\u1E8A\u1E8C"
}, {
  base: "Y",
  letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
}, {
  base: "Z",
  letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
}, {
  base: "a",
  letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
}, {
  base: "aa",
  letters: "\uA733"
}, {
  base: "ae",
  letters: "\xE6\u01FD\u01E3"
}, {
  base: "ao",
  letters: "\uA735"
}, {
  base: "au",
  letters: "\uA737"
}, {
  base: "av",
  letters: "\uA739\uA73B"
}, {
  base: "ay",
  letters: "\uA73D"
}, {
  base: "b",
  letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
}, {
  base: "c",
  letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
}, {
  base: "d",
  letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
}, {
  base: "dz",
  letters: "\u01F3\u01C6"
}, {
  base: "e",
  letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
}, {
  base: "f",
  letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
}, {
  base: "g",
  letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
}, {
  base: "h",
  letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
}, {
  base: "hv",
  letters: "\u0195"
}, {
  base: "i",
  letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
}, {
  base: "j",
  letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
}, {
  base: "k",
  letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
}, {
  base: "l",
  letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
}, {
  base: "lj",
  letters: "\u01C9"
}, {
  base: "m",
  letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
}, {
  base: "n",
  letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
}, {
  base: "nj",
  letters: "\u01CC"
}, {
  base: "o",
  letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
}, {
  base: "oi",
  letters: "\u01A3"
}, {
  base: "ou",
  letters: "\u0223"
}, {
  base: "oo",
  letters: "\uA74F"
}, {
  base: "p",
  letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
}, {
  base: "q",
  letters: "q\u24E0\uFF51\u024B\uA757\uA759"
}, {
  base: "r",
  letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
}, {
  base: "s",
  letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
}, {
  base: "t",
  letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
}, {
  base: "tz",
  letters: "\uA729"
}, {
  base: "u",
  letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
}, {
  base: "v",
  letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
}, {
  base: "vy",
  letters: "\uA761"
}, {
  base: "w",
  letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
}, {
  base: "x",
  letters: "x\u24E7\uFF58\u1E8B\u1E8D"
}, {
  base: "y",
  letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
}, {
  base: "z",
  letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
}], Zt = new RegExp("[" + le.map(function(r) {
  return r.letters;
}).join("") + "]", "g"), Le = {};
for (var ie = 0; ie < le.length; ie++)
  for (var oe = le[ie], ae = 0; ae < oe.letters.length; ae++)
    Le[oe.letters[ae]] = oe.base;
var Ge = function(n) {
  return n.replace(Zt, function(s) {
    return Le[s];
  });
}, Rt = Ot(Ge), Ce = function(n) {
  return n.replace(/^\s+|\s+$/g, "");
}, Wt = function(n) {
  return "".concat(n.label, " ").concat(n.value);
}, Xt = function(n) {
  return function(s, a) {
    if (s.data.__isNew__)
      return !0;
    var e = y({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Wt,
      trim: !0,
      matchFrom: "any"
    }, n), i = e.ignoreCase, c = e.ignoreAccents, t = e.stringify, u = e.trim, o = e.matchFrom, l = u ? Ce(a) : a, d = u ? Ce(t(s)) : t(s);
    return i && (l = l.toLowerCase(), d = d.toLowerCase()), c && (l = Rt(l), d = Ge(d)), o === "start" ? d.substr(0, l.length) === l : d.indexOf(l) > -1;
  };
}, wt = ["innerRef"];
function Tt(r) {
  var n = r.innerRef, s = yt(r, wt), a = ut(s, "onExited", "in", "enter", "exit", "appear");
  return L("input", ye({
    ref: n
  }, a, {
    css: /* @__PURE__ */ St({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Ht = function(n) {
  n.preventDefault(), n.stopPropagation();
};
function kt(r) {
  var n = r.isEnabled, s = r.onBottomArrive, a = r.onBottomLeave, e = r.onTopArrive, i = r.onTopLeave, c = Y(!1), t = Y(!1), u = Y(0), o = Y(null), l = w(function(p, h) {
    if (o.current !== null) {
      var A = o.current, I = A.scrollTop, m = A.scrollHeight, B = A.clientHeight, C = o.current, D = h > 0, F = m - B - I, M = !1;
      F > h && c.current && (a && a(p), c.current = !1), D && t.current && (i && i(p), t.current = !1), D && h > F ? (s && !c.current && s(p), C.scrollTop = m, M = !0, c.current = !0) : !D && -h > I && (e && !t.current && e(p), C.scrollTop = 0, M = !0, t.current = !0), M && Ht(p);
    }
  }, [s, a, e, i]), d = w(function(p) {
    l(p, p.deltaY);
  }, [l]), f = w(function(p) {
    u.current = p.changedTouches[0].clientY;
  }, []), v = w(function(p) {
    var h = u.current - p.changedTouches[0].clientY;
    l(p, h);
  }, [l]), b = w(function(p) {
    if (!!p) {
      var h = xt ? {
        passive: !1
      } : !1;
      p.addEventListener("wheel", d, h), p.addEventListener("touchstart", f, h), p.addEventListener("touchmove", v, h);
    }
  }, [v, f, d]), g = w(function(p) {
    !p || (p.removeEventListener("wheel", d, !1), p.removeEventListener("touchstart", f, !1), p.removeEventListener("touchmove", v, !1));
  }, [v, f, d]);
  return Me(function() {
    if (!!n) {
      var p = o.current;
      return b(p), function() {
        g(p);
      };
    }
  }, [n, b, g]), function(p) {
    o.current = p;
  };
}
var Ie = ["boxSizing", "height", "overflow", "paddingRight", "position"], Ee = {
  boxSizing: "border-box",
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function Fe(r) {
  r.preventDefault();
}
function Ae(r) {
  r.stopPropagation();
}
function Ve() {
  var r = this.scrollTop, n = this.scrollHeight, s = r + this.offsetHeight;
  r === 0 ? this.scrollTop = 1 : s === n && (this.scrollTop = r - 1);
}
function De() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var xe = !!(typeof window < "u" && window.document && window.document.createElement), Q = 0, P = {
  capture: !1,
  passive: !1
};
function Nt(r) {
  var n = r.isEnabled, s = r.accountForScrollbars, a = s === void 0 ? !0 : s, e = Y({}), i = Y(null), c = w(function(u) {
    if (!!xe) {
      var o = document.body, l = o && o.style;
      if (a && Ie.forEach(function(b) {
        var g = l && l[b];
        e.current[b] = g;
      }), a && Q < 1) {
        var d = parseInt(e.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, v = window.innerWidth - f + d || 0;
        Object.keys(Ee).forEach(function(b) {
          var g = Ee[b];
          l && (l[b] = g);
        }), l && (l.paddingRight = "".concat(v, "px"));
      }
      o && De() && (o.addEventListener("touchmove", Fe, P), u && (u.addEventListener("touchstart", Ve, P), u.addEventListener("touchmove", Ae, P))), Q += 1;
    }
  }, [a]), t = w(function(u) {
    if (!!xe) {
      var o = document.body, l = o && o.style;
      Q = Math.max(Q - 1, 0), a && Q < 1 && Ie.forEach(function(d) {
        var f = e.current[d];
        l && (l[d] = f);
      }), o && De() && (o.removeEventListener("touchmove", Fe, P), u && (u.removeEventListener("touchstart", Ve, P), u.removeEventListener("touchmove", Ae, P)));
    }
  }, [a]);
  return Me(function() {
    if (!!n) {
      var u = i.current;
      return c(u), function() {
        t(u);
      };
    }
  }, [n, c, t]), function(u) {
    i.current = u;
  };
}
function Jt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Pt = function() {
  return document.activeElement && document.activeElement.blur();
}, Yt = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Jt
};
function Ut(r) {
  var n = r.children, s = r.lockEnabled, a = r.captureEnabled, e = a === void 0 ? !0 : a, i = r.onBottomArrive, c = r.onBottomLeave, t = r.onTopArrive, u = r.onTopLeave, o = kt({
    isEnabled: e,
    onBottomArrive: i,
    onBottomLeave: c,
    onTopArrive: t,
    onTopLeave: u
  }), l = Nt({
    isEnabled: s
  }), d = function(v) {
    o(v), l(v);
  };
  return L(re, null, s && L("div", {
    onClick: Pt,
    css: Yt
  }), n(d));
}
function zt() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var jt = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: zt
}, Qt = function(n) {
  var s = n.name, a = n.onFocus;
  return L("input", {
    required: !0,
    name: s,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: a,
    css: jt,
    value: "",
    onChange: function() {
    }
  });
}, _t = function(n) {
  return n.label;
}, $t = function(n) {
  return n.label;
}, Kt = function(n) {
  return n.value;
}, qt = function(n) {
  return !!n.isDisabled;
}, eu = {
  clearIndicator: nt,
  container: it,
  control: ot,
  dropdownIndicator: at,
  group: st,
  groupHeading: rt,
  indicatorsContainer: lt,
  indicatorSeparator: ct,
  input: dt,
  loadingIndicator: pt,
  loadingMessage: ft,
  menu: bt,
  menuList: gt,
  menuPortal: vt,
  multiValue: ht,
  multiValueLabel: mt,
  multiValueRemove: Ct,
  noOptionsMessage: It,
  option: Et,
  placeholder: Ft,
  singleValue: At,
  valueContainer: Vt
}, tu = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, uu = 4, Ze = 4, nu = 38, iu = Ze * 2, ou = {
  baseUnit: Ze,
  controlHeight: nu,
  menuGutter: iu
}, se = {
  borderRadius: uu,
  colors: tu,
  spacing: ou
}, au = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: fe(),
  captureMenuScroll: !fe(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Xt(),
  formatGroupLabel: _t,
  getOptionLabel: $t,
  getOptionValue: Kt,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: qt,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !_e(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(n) {
    var s = n.count;
    return "".concat(s, " result").concat(s !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Se(r, n, s, a) {
  var e = we(r, n, s), i = Te(r, n, s), c = Xe(r, n), t = ne(r, n);
  return {
    type: "option",
    data: n,
    isDisabled: e,
    isSelected: i,
    label: c,
    value: t,
    index: a
  };
}
function Re(r, n) {
  return r.options.map(function(s, a) {
    if ("options" in s) {
      var e = s.options.map(function(c, t) {
        return Se(r, c, n, t);
      }).filter(function(c) {
        return Oe(r, c);
      });
      return e.length > 0 ? {
        type: "group",
        data: s,
        options: e,
        index: a
      } : void 0;
    }
    var i = Se(r, s, n, a);
    return Oe(r, i) ? i : void 0;
  }).filter(Dt);
}
function We(r) {
  return r.reduce(function(n, s) {
    return s.type === "group" ? n.push.apply(n, Be(s.options.map(function(a) {
      return a.data;
    }))) : n.push(s.data), n;
  }, []);
}
function su(r, n) {
  return We(Re(r, n));
}
function Oe(r, n) {
  var s = r.inputValue, a = s === void 0 ? "" : s, e = n.data, i = n.isSelected, c = n.label, t = n.value;
  return (!ke(r) || !i) && He(r, {
    label: c,
    value: t,
    data: e
  }, a);
}
function ru(r, n) {
  var s = r.focusedValue, a = r.selectValue, e = a.indexOf(s);
  if (e > -1) {
    var i = n.indexOf(s);
    if (i > -1)
      return s;
    if (e < n.length)
      return n[e];
  }
  return null;
}
function lu(r, n) {
  var s = r.focusedOption;
  return s && n.indexOf(s) > -1 ? s : n[0];
}
var Xe = function(n, s) {
  return n.getOptionLabel(s);
}, ne = function(n, s) {
  return n.getOptionValue(s);
};
function we(r, n, s) {
  return typeof r.isOptionDisabled == "function" ? r.isOptionDisabled(n, s) : !1;
}
function Te(r, n, s) {
  if (s.indexOf(n) > -1)
    return !0;
  if (typeof r.isOptionSelected == "function")
    return r.isOptionSelected(n, s);
  var a = ne(r, n);
  return s.some(function(e) {
    return ne(r, e) === a;
  });
}
function He(r, n, s) {
  return r.filterOption ? r.filterOption(n, s) : !0;
}
var ke = function(n) {
  var s = n.hideSelectedOptions, a = n.isMulti;
  return s === void 0 ? a : s;
}, cu = 1, du = /* @__PURE__ */ function(r) {
  ze(s, r);
  var n = je(s);
  function s(a) {
    var e;
    if (Ye(this, s), e = n.call(this, a), e.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0
    }, e.blockOptionHover = !1, e.isComposing = !1, e.commonProps = void 0, e.initialTouchX = 0, e.initialTouchY = 0, e.instancePrefix = "", e.openAfterFocus = !1, e.scrollToFocusedOptionOnUpdate = !1, e.userIsDragging = void 0, e.controlRef = null, e.getControlRef = function(t) {
      e.controlRef = t;
    }, e.focusedOptionRef = null, e.getFocusedOptionRef = function(t) {
      e.focusedOptionRef = t;
    }, e.menuListRef = null, e.getMenuListRef = function(t) {
      e.menuListRef = t;
    }, e.inputRef = null, e.getInputRef = function(t) {
      e.inputRef = t;
    }, e.focus = e.focusInput, e.blur = e.blurInput, e.onChange = function(t, u) {
      var o = e.props, l = o.onChange, d = o.name;
      u.name = d, e.ariaOnChange(t, u), l(t, u);
    }, e.setValue = function(t, u, o) {
      var l = e.props, d = l.closeMenuOnSelect, f = l.isMulti, v = l.inputValue;
      e.onInputChange("", {
        action: "set-value",
        prevInputValue: v
      }), d && (e.setState({
        inputIsHiddenAfterUpdate: !f
      }), e.onMenuClose()), e.setState({
        clearFocusValueOnUpdate: !0
      }), e.onChange(t, {
        action: u,
        option: o
      });
    }, e.selectOption = function(t) {
      var u = e.props, o = u.blurInputOnSelect, l = u.isMulti, d = u.name, f = e.state.selectValue, v = l && e.isOptionSelected(t, f), b = e.isOptionDisabled(t, f);
      if (v) {
        var g = e.getOptionValue(t);
        e.setValue(be(f.filter(function(p) {
          return e.getOptionValue(p) !== g;
        })), "deselect-option", t);
      } else if (!b)
        l ? e.setValue(be([].concat(Be(f), [t])), "select-option", t) : e.setValue(ge(t), "select-option");
      else {
        e.ariaOnChange(ge(t), {
          action: "select-option",
          option: t,
          name: d
        });
        return;
      }
      o && e.blurInput();
    }, e.removeValue = function(t) {
      var u = e.props.isMulti, o = e.state.selectValue, l = e.getOptionValue(t), d = o.filter(function(v) {
        return e.getOptionValue(v) !== l;
      }), f = te(u, d, d[0] || null);
      e.onChange(f, {
        action: "remove-value",
        removedValue: t
      }), e.focusInput();
    }, e.clearValue = function() {
      var t = e.state.selectValue;
      e.onChange(te(e.props.isMulti, [], null), {
        action: "clear",
        removedValues: t
      });
    }, e.popValue = function() {
      var t = e.props.isMulti, u = e.state.selectValue, o = u[u.length - 1], l = u.slice(0, u.length - 1), d = te(t, l, l[0] || null);
      e.onChange(d, {
        action: "pop-value",
        removedValue: o
      });
    }, e.getValue = function() {
      return e.state.selectValue;
    }, e.cx = function() {
      for (var t = arguments.length, u = new Array(t), o = 0; o < t; o++)
        u[o] = arguments[o];
      return $e.apply(void 0, [e.props.classNamePrefix].concat(u));
    }, e.getOptionLabel = function(t) {
      return Xe(e.props, t);
    }, e.getOptionValue = function(t) {
      return ne(e.props, t);
    }, e.getStyles = function(t, u) {
      var o = e.props.unstyled, l = eu[t](u, o);
      l.boxSizing = "border-box";
      var d = e.props.styles[t];
      return d ? d(l, u) : l;
    }, e.getClassNames = function(t, u) {
      var o, l;
      return (o = (l = e.props.classNames)[t]) === null || o === void 0 ? void 0 : o.call(l, u);
    }, e.getElementId = function(t) {
      return "".concat(e.instancePrefix, "-").concat(t);
    }, e.getComponents = function() {
      return Ke(e.props);
    }, e.buildCategorizedOptions = function() {
      return Re(e.props, e.state.selectValue);
    }, e.getCategorizedOptions = function() {
      return e.props.menuIsOpen ? e.buildCategorizedOptions() : [];
    }, e.buildFocusableOptions = function() {
      return We(e.buildCategorizedOptions());
    }, e.getFocusableOptions = function() {
      return e.props.menuIsOpen ? e.buildFocusableOptions() : [];
    }, e.ariaOnChange = function(t, u) {
      e.setState({
        ariaSelection: y({
          value: t
        }, u)
      });
    }, e.onMenuMouseDown = function(t) {
      t.button === 0 && (t.stopPropagation(), t.preventDefault(), e.focusInput());
    }, e.onMenuMouseMove = function(t) {
      e.blockOptionHover = !1;
    }, e.onControlMouseDown = function(t) {
      if (!t.defaultPrevented) {
        var u = e.props.openMenuOnClick;
        e.state.isFocused ? e.props.menuIsOpen ? t.target.tagName !== "INPUT" && t.target.tagName !== "TEXTAREA" && e.onMenuClose() : u && e.openMenu("first") : (u && (e.openAfterFocus = !0), e.focusInput()), t.target.tagName !== "INPUT" && t.target.tagName !== "TEXTAREA" && t.preventDefault();
      }
    }, e.onDropdownIndicatorMouseDown = function(t) {
      if (!(t && t.type === "mousedown" && t.button !== 0) && !e.props.isDisabled) {
        var u = e.props, o = u.isMulti, l = u.menuIsOpen;
        e.focusInput(), l ? (e.setState({
          inputIsHiddenAfterUpdate: !o
        }), e.onMenuClose()) : e.openMenu("first"), t.preventDefault();
      }
    }, e.onClearIndicatorMouseDown = function(t) {
      t && t.type === "mousedown" && t.button !== 0 || (e.clearValue(), t.preventDefault(), e.openAfterFocus = !1, t.type === "touchend" ? e.focusInput() : setTimeout(function() {
        return e.focusInput();
      }));
    }, e.onScroll = function(t) {
      typeof e.props.closeMenuOnScroll == "boolean" ? t.target instanceof HTMLElement && qe(t.target) && e.props.onMenuClose() : typeof e.props.closeMenuOnScroll == "function" && e.props.closeMenuOnScroll(t) && e.props.onMenuClose();
    }, e.onCompositionStart = function() {
      e.isComposing = !0;
    }, e.onCompositionEnd = function() {
      e.isComposing = !1;
    }, e.onTouchStart = function(t) {
      var u = t.touches, o = u && u.item(0);
      !o || (e.initialTouchX = o.clientX, e.initialTouchY = o.clientY, e.userIsDragging = !1);
    }, e.onTouchMove = function(t) {
      var u = t.touches, o = u && u.item(0);
      if (!!o) {
        var l = Math.abs(o.clientX - e.initialTouchX), d = Math.abs(o.clientY - e.initialTouchY), f = 5;
        e.userIsDragging = l > f || d > f;
      }
    }, e.onTouchEnd = function(t) {
      e.userIsDragging || (e.controlRef && !e.controlRef.contains(t.target) && e.menuListRef && !e.menuListRef.contains(t.target) && e.blurInput(), e.initialTouchX = 0, e.initialTouchY = 0);
    }, e.onControlTouchEnd = function(t) {
      e.userIsDragging || e.onControlMouseDown(t);
    }, e.onClearIndicatorTouchEnd = function(t) {
      e.userIsDragging || e.onClearIndicatorMouseDown(t);
    }, e.onDropdownIndicatorTouchEnd = function(t) {
      e.userIsDragging || e.onDropdownIndicatorMouseDown(t);
    }, e.handleInputChange = function(t) {
      var u = e.props.inputValue, o = t.currentTarget.value;
      e.setState({
        inputIsHiddenAfterUpdate: !1
      }), e.onInputChange(o, {
        action: "input-change",
        prevInputValue: u
      }), e.props.menuIsOpen || e.onMenuOpen();
    }, e.onInputFocus = function(t) {
      e.props.onFocus && e.props.onFocus(t), e.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (e.openAfterFocus || e.props.openMenuOnFocus) && e.openMenu("first"), e.openAfterFocus = !1;
    }, e.onInputBlur = function(t) {
      var u = e.props.inputValue;
      if (e.menuListRef && e.menuListRef.contains(document.activeElement)) {
        e.inputRef.focus();
        return;
      }
      e.props.onBlur && e.props.onBlur(t), e.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), e.onMenuClose(), e.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, e.onOptionHover = function(t) {
      e.blockOptionHover || e.state.focusedOption === t || e.setState({
        focusedOption: t
      });
    }, e.shouldHideSelectedOptions = function() {
      return ke(e.props);
    }, e.onValueInputFocus = function(t) {
      t.preventDefault(), t.stopPropagation(), e.focus();
    }, e.onKeyDown = function(t) {
      var u = e.props, o = u.isMulti, l = u.backspaceRemovesValue, d = u.escapeClearsValue, f = u.inputValue, v = u.isClearable, b = u.isDisabled, g = u.menuIsOpen, p = u.onKeyDown, h = u.tabSelectsValue, A = u.openMenuOnFocus, I = e.state, m = I.focusedOption, B = I.focusedValue, C = I.selectValue;
      if (!b && !(typeof p == "function" && (p(t), t.defaultPrevented))) {
        switch (e.blockOptionHover = !0, t.key) {
          case "ArrowLeft":
            if (!o || f)
              return;
            e.focusValue("previous");
            break;
          case "ArrowRight":
            if (!o || f)
              return;
            e.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (f)
              return;
            if (B)
              e.removeValue(B);
            else {
              if (!l)
                return;
              o ? e.popValue() : v && e.clearValue();
            }
            break;
          case "Tab":
            if (e.isComposing || t.shiftKey || !g || !h || !m || A && e.isOptionSelected(m, C))
              return;
            e.selectOption(m);
            break;
          case "Enter":
            if (t.keyCode === 229)
              break;
            if (g) {
              if (!m || e.isComposing)
                return;
              e.selectOption(m);
              break;
            }
            return;
          case "Escape":
            g ? (e.setState({
              inputIsHiddenAfterUpdate: !1
            }), e.onInputChange("", {
              action: "menu-close",
              prevInputValue: f
            }), e.onMenuClose()) : v && d && e.clearValue();
            break;
          case " ":
            if (f)
              return;
            if (!g) {
              e.openMenu("first");
              break;
            }
            if (!m)
              return;
            e.selectOption(m);
            break;
          case "ArrowUp":
            g ? e.focusOption("up") : e.openMenu("last");
            break;
          case "ArrowDown":
            g ? e.focusOption("down") : e.openMenu("first");
            break;
          case "PageUp":
            if (!g)
              return;
            e.focusOption("pageup");
            break;
          case "PageDown":
            if (!g)
              return;
            e.focusOption("pagedown");
            break;
          case "Home":
            if (!g)
              return;
            e.focusOption("first");
            break;
          case "End":
            if (!g)
              return;
            e.focusOption("last");
            break;
          default:
            return;
        }
        t.preventDefault();
      }
    }, e.instancePrefix = "react-select-" + (e.props.instanceId || ++cu), e.state.selectValue = ve(a.value), a.menuIsOpen && e.state.selectValue.length) {
      var i = e.buildFocusableOptions(), c = i.indexOf(e.state.selectValue[0]);
      e.state.focusedOption = i[c];
    }
    return e;
  }
  return Ue(s, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && he(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(e) {
      var i = this.props, c = i.isDisabled, t = i.menuIsOpen, u = this.state.isFocused;
      (u && !c && e.isDisabled || u && t && !e.menuIsOpen) && this.focusInput(), u && c && !e.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !u && !c && e.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (he(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(e, i) {
      this.props.onInputChange(e, i);
    }
  }, {
    key: "focusInput",
    value: function() {
      !this.inputRef || this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      !this.inputRef || this.inputRef.blur();
    }
  }, {
    key: "openMenu",
    value: function(e) {
      var i = this, c = this.state, t = c.selectValue, u = c.isFocused, o = this.buildFocusableOptions(), l = e === "first" ? 0 : o.length - 1;
      if (!this.props.isMulti) {
        var d = o.indexOf(t[0]);
        d > -1 && (l = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(u && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: o[l]
      }, function() {
        return i.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(e) {
      var i = this.state, c = i.selectValue, t = i.focusedValue;
      if (!!this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var u = c.indexOf(t);
        t || (u = -1);
        var o = c.length - 1, l = -1;
        if (!!c.length) {
          switch (e) {
            case "previous":
              u === 0 ? l = 0 : u === -1 ? l = o : l = u - 1;
              break;
            case "next":
              u > -1 && u < o && (l = u + 1);
              break;
          }
          this.setState({
            inputIsHidden: l !== -1,
            focusedValue: c[l]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", i = this.props.pageSize, c = this.state.focusedOption, t = this.getFocusableOptions();
      if (!!t.length) {
        var u = 0, o = t.indexOf(c);
        c || (o = -1), e === "up" ? u = o > 0 ? o - 1 : t.length - 1 : e === "down" ? u = (o + 1) % t.length : e === "pageup" ? (u = o - i, u < 0 && (u = 0)) : e === "pagedown" ? (u = o + i, u > t.length - 1 && (u = t.length - 1)) : e === "last" && (u = t.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: t[u],
          focusedValue: null
        });
      }
    }
  }, {
    key: "getTheme",
    value: function() {
      return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(se) : y(y({}, se), this.props.theme) : se;
    }
  }, {
    key: "getCommonProps",
    value: function() {
      var e = this.clearValue, i = this.cx, c = this.getStyles, t = this.getClassNames, u = this.getValue, o = this.selectOption, l = this.setValue, d = this.props, f = d.isMulti, v = d.isRtl, b = d.options, g = this.hasValue();
      return {
        clearValue: e,
        cx: i,
        getStyles: c,
        getClassNames: t,
        getValue: u,
        hasValue: g,
        isMulti: f,
        isRtl: v,
        options: b,
        selectOption: o,
        selectProps: d,
        setValue: l,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var e = this.state.selectValue;
      return e.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var e = this.props, i = e.isClearable, c = e.isMulti;
      return i === void 0 ? c : i;
    }
  }, {
    key: "isOptionDisabled",
    value: function(e, i) {
      return we(this.props, e, i);
    }
  }, {
    key: "isOptionSelected",
    value: function(e, i) {
      return Te(this.props, e, i);
    }
  }, {
    key: "filterOption",
    value: function(e, i) {
      return He(this.props, e, i);
    }
  }, {
    key: "formatOptionLabel",
    value: function(e, i) {
      if (typeof this.props.formatOptionLabel == "function") {
        var c = this.props.inputValue, t = this.state.selectValue;
        return this.props.formatOptionLabel(e, {
          context: i,
          inputValue: c,
          selectValue: t
        });
      } else
        return this.getOptionLabel(e);
    }
  }, {
    key: "formatGroupLabel",
    value: function(e) {
      return this.props.formatGroupLabel(e);
    }
  }, {
    key: "startListeningComposition",
    value: function() {
      document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
    }
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: function() {
      document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
    }
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: function() {
      var e = this.props, i = e.isDisabled, c = e.isSearchable, t = e.inputId, u = e.inputValue, o = e.tabIndex, l = e.form, d = e.menuIsOpen, f = e.required, v = this.getComponents(), b = v.Input, g = this.state, p = g.inputIsHidden, h = g.ariaSelection, A = this.commonProps, I = t || this.getElementId("input"), m = y(y(y({
        "aria-autocomplete": "list",
        "aria-expanded": d,
        "aria-haspopup": !0,
        "aria-errormessage": this.props["aria-errormessage"],
        "aria-invalid": this.props["aria-invalid"],
        "aria-label": this.props["aria-label"],
        "aria-labelledby": this.props["aria-labelledby"],
        "aria-required": f,
        role: "combobox"
      }, d && {
        "aria-controls": this.getElementId("listbox"),
        "aria-owns": this.getElementId("listbox")
      }), !c && {
        "aria-readonly": !0
      }), this.hasValue() ? (h == null ? void 0 : h.action) === "initial-input-focus" && {
        "aria-describedby": this.getElementId("live-region")
      } : {
        "aria-describedby": this.getElementId("placeholder")
      });
      return c ? /* @__PURE__ */ E(b, {
        ...A,
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        id: I,
        innerRef: this.getInputRef,
        isDisabled: i,
        isHidden: p,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: "false",
        tabIndex: o,
        form: l,
        type: "text",
        value: u,
        ...m
      }) : /* @__PURE__ */ E(Tt, {
        id: I,
        innerRef: this.getInputRef,
        onBlur: this.onInputBlur,
        onChange: et,
        onFocus: this.onInputFocus,
        disabled: i,
        tabIndex: o,
        inputMode: "none",
        form: l,
        value: "",
        ...m
      });
    }
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var e = this, i = this.getComponents(), c = i.MultiValue, t = i.MultiValueContainer, u = i.MultiValueLabel, o = i.MultiValueRemove, l = i.SingleValue, d = i.Placeholder, f = this.commonProps, v = this.props, b = v.controlShouldRenderValue, g = v.isDisabled, p = v.isMulti, h = v.inputValue, A = v.placeholder, I = this.state, m = I.selectValue, B = I.focusedValue, C = I.isFocused;
      if (!this.hasValue() || !b)
        return h ? null : /* @__PURE__ */ ee(d, {
          ...f,
          key: "placeholder",
          isDisabled: g,
          isFocused: C,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }, A);
      if (p)
        return m.map(function(F, M) {
          var k = F === B, U = "".concat(e.getOptionLabel(F), "-").concat(e.getOptionValue(F));
          return /* @__PURE__ */ ee(c, {
            ...f,
            components: {
              Container: t,
              Label: u,
              Remove: o
            },
            isFocused: k,
            isDisabled: g,
            key: U,
            index: M,
            removeProps: {
              onClick: function() {
                return e.removeValue(F);
              },
              onTouchEnd: function() {
                return e.removeValue(F);
              },
              onMouseDown: function(N) {
                N.preventDefault();
              }
            },
            data: F
          }, e.formatOptionLabel(F, "value"));
        });
      if (h)
        return null;
      var D = m[0];
      return /* @__PURE__ */ E(l, {
        ...f,
        data: D,
        isDisabled: g,
        children: this.formatOptionLabel(D, "value")
      });
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var e = this.getComponents(), i = e.ClearIndicator, c = this.commonProps, t = this.props, u = t.isDisabled, o = t.isLoading, l = this.state.isFocused;
      if (!this.isClearable() || !i || u || !this.hasValue() || o)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ E(i, {
        ...c,
        innerProps: d,
        isFocused: l
      });
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var e = this.getComponents(), i = e.LoadingIndicator, c = this.commonProps, t = this.props, u = t.isDisabled, o = t.isLoading, l = this.state.isFocused;
      if (!i || !o)
        return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ E(i, {
        ...c,
        innerProps: d,
        isDisabled: u,
        isFocused: l
      });
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var e = this.getComponents(), i = e.DropdownIndicator, c = e.IndicatorSeparator;
      if (!i || !c)
        return null;
      var t = this.commonProps, u = this.props.isDisabled, o = this.state.isFocused;
      return /* @__PURE__ */ E(c, {
        ...t,
        isDisabled: u,
        isFocused: o
      });
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var e = this.getComponents(), i = e.DropdownIndicator;
      if (!i)
        return null;
      var c = this.commonProps, t = this.props.isDisabled, u = this.state.isFocused, o = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ E(i, {
        ...c,
        innerProps: o,
        isDisabled: t,
        isFocused: u
      });
    }
  }, {
    key: "renderMenu",
    value: function() {
      var e = this, i = this.getComponents(), c = i.Group, t = i.GroupHeading, u = i.Menu, o = i.MenuList, l = i.MenuPortal, d = i.LoadingMessage, f = i.NoOptionsMessage, v = i.Option, b = this.commonProps, g = this.state.focusedOption, p = this.props, h = p.captureMenuScroll, A = p.inputValue, I = p.isLoading, m = p.loadingMessage, B = p.minMenuHeight, C = p.maxMenuHeight, D = p.menuIsOpen, F = p.menuPlacement, M = p.menuPosition, k = p.menuPortalTarget, U = p.menuShouldBlockScroll, T = p.menuShouldScrollIntoView, N = p.noOptionsMessage, S = p.onMenuScrollToTop, O = p.onMenuScrollToBottom;
      if (!D)
        return null;
      var J = function(x, W) {
        var X = x.type, G = x.data, Z = x.isDisabled, z = x.isSelected, q = x.label, Ne = x.value, ce = g === G, de = Z ? void 0 : function() {
          return e.onOptionHover(G);
        }, Je = Z ? void 0 : function() {
          return e.selectOption(G);
        }, pe = "".concat(e.getElementId("option"), "-").concat(W), Pe = {
          id: pe,
          onClick: Je,
          onMouseMove: de,
          onMouseOver: de,
          tabIndex: -1
        };
        return /* @__PURE__ */ ee(v, {
          ...b,
          innerProps: Pe,
          data: G,
          isDisabled: Z,
          isSelected: z,
          key: pe,
          label: q,
          type: X,
          value: Ne,
          isFocused: ce,
          innerRef: ce ? e.getFocusedOptionRef : void 0
        }, e.formatOptionLabel(x.data, "menu"));
      }, R;
      if (this.hasOptions())
        R = this.getCategorizedOptions().map(function(V) {
          if (V.type === "group") {
            var x = V.data, W = V.options, X = V.index, G = "".concat(e.getElementId("group"), "-").concat(X), Z = "".concat(G, "-heading");
            return /* @__PURE__ */ ee(c, {
              ...b,
              key: G,
              data: x,
              options: W,
              Heading: t,
              headingProps: {
                id: Z,
                data: V.data
              },
              label: e.formatGroupLabel(V.data)
            }, V.options.map(function(z) {
              return J(z, "".concat(X, "-").concat(z.index));
            }));
          } else if (V.type === "option")
            return J(V, "".concat(V.index));
        });
      else if (I) {
        var _ = m({
          inputValue: A
        });
        if (_ === null)
          return null;
        R = /* @__PURE__ */ E(d, {
          ...b,
          children: _
        });
      } else {
        var $ = N({
          inputValue: A
        });
        if ($ === null)
          return null;
        R = /* @__PURE__ */ E(f, {
          ...b,
          children: $
        });
      }
      var K = {
        minMenuHeight: B,
        maxMenuHeight: C,
        menuPlacement: F,
        menuPosition: M,
        menuShouldScrollIntoView: T
      }, H = /* @__PURE__ */ E(tt, {
        ...b,
        ...K,
        children: function(V) {
          var x = V.ref, W = V.placerProps, X = W.placement, G = W.maxHeight;
          return /* @__PURE__ */ E(u, {
            ...b,
            ...K,
            innerRef: x,
            innerProps: {
              onMouseDown: e.onMenuMouseDown,
              onMouseMove: e.onMenuMouseMove,
              id: e.getElementId("listbox")
            },
            isLoading: I,
            placement: X,
            children: /* @__PURE__ */ E(Ut, {
              captureEnabled: h,
              onTopArrive: S,
              onBottomArrive: O,
              lockEnabled: U,
              children: function(Z) {
                return /* @__PURE__ */ E(o, {
                  ...b,
                  innerRef: function(q) {
                    e.getMenuListRef(q), Z(q);
                  },
                  isLoading: I,
                  maxHeight: G,
                  focusedOption: g,
                  children: R
                });
              }
            })
          });
        }
      });
      return k || M === "fixed" ? /* @__PURE__ */ E(l, {
        ...b,
        appendTo: k,
        controlElement: this.controlRef,
        menuPlacement: F,
        menuPosition: M,
        children: H
      }) : H;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var e = this, i = this.props, c = i.delimiter, t = i.isDisabled, u = i.isMulti, o = i.name, l = i.required, d = this.state.selectValue;
      if (l && !this.hasValue() && !t)
        return /* @__PURE__ */ E(Qt, {
          name: o,
          onFocus: this.onValueInputFocus
        });
      if (!(!o || t))
        if (u)
          if (c) {
            var f = d.map(function(g) {
              return e.getOptionValue(g);
            }).join(c);
            return /* @__PURE__ */ E("input", {
              name: o,
              type: "hidden",
              value: f
            });
          } else {
            var v = d.length > 0 ? d.map(function(g, p) {
              return /* @__PURE__ */ E("input", {
                name: o,
                type: "hidden",
                value: e.getOptionValue(g)
              }, "i-".concat(p));
            }) : /* @__PURE__ */ E("input", {
              name: o,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ E("div", {
              children: v
            });
          }
        else {
          var b = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ E("input", {
            name: o,
            type: "hidden",
            value: b
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var e = this.commonProps, i = this.state, c = i.ariaSelection, t = i.focusedOption, u = i.focusedValue, o = i.isFocused, l = i.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ E(Gt, {
        ...e,
        id: this.getElementId("live-region"),
        ariaSelection: c,
        focusedOption: t,
        focusedValue: u,
        isFocused: o,
        selectValue: l,
        focusableOptions: d
      });
    }
  }, {
    key: "render",
    value: function() {
      var e = this.getComponents(), i = e.Control, c = e.IndicatorsContainer, t = e.SelectContainer, u = e.ValueContainer, o = this.props, l = o.className, d = o.id, f = o.isDisabled, v = o.menuIsOpen, b = this.state.isFocused, g = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ ue(t, {
        ...g,
        className: l,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: b,
        children: [this.renderLiveRegion(), /* @__PURE__ */ ue(i, {
          ...g,
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: f,
          isFocused: b,
          menuIsOpen: v,
          children: [/* @__PURE__ */ ue(u, {
            ...g,
            isDisabled: f,
            children: [this.renderPlaceholderOrValue(), this.renderInput()]
          }), /* @__PURE__ */ ue(c, {
            ...g,
            isDisabled: f,
            children: [this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator()]
          })]
        }), this.renderMenu(), this.renderFormField()]
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(e, i) {
      var c = i.prevProps, t = i.clearFocusValueOnUpdate, u = i.inputIsHiddenAfterUpdate, o = i.ariaSelection, l = i.isFocused, d = i.prevWasFocused, f = e.options, v = e.value, b = e.menuIsOpen, g = e.inputValue, p = e.isMulti, h = ve(v), A = {};
      if (c && (v !== c.value || f !== c.options || b !== c.menuIsOpen || g !== c.inputValue)) {
        var I = b ? su(e, h) : [], m = t ? ru(i, h) : null, B = lu(i, I);
        A = {
          selectValue: h,
          focusedOption: B,
          focusedValue: m,
          clearFocusValueOnUpdate: !1
        };
      }
      var C = u != null && e !== c ? {
        inputIsHidden: u,
        inputIsHiddenAfterUpdate: void 0
      } : {}, D = o, F = l && d;
      return l && !F && (D = {
        value: te(p, h, h[0] || null),
        options: h,
        action: "initial-input-focus"
      }, F = !d), (o == null ? void 0 : o.action) === "initial-input-focus" && (D = null), y(y(y({}, A), C), {}, {
        prevProps: e,
        ariaSelection: D,
        prevWasFocused: F
      });
    }
  }]), s;
}(Qe);
du.defaultProps = au;
export {
  du as S,
  au as a,
  $t as b,
  Xt as c,
  se as d,
  Kt as g
};
//# sourceMappingURL=Select-457c486b.esm.js.map
